var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-skeleton-loader',{staticClass:"skeleton-card",attrs:{"cols":"12","sm":"6","md":"4","lg":"3","type":"image, article","rounded":"","outlined":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }